import {
  saveTokens as saveTokensToStorage,
  clearTokens,
  // getRefreshToken,
  isTokenValid,
  debugTokens,
} from "@/utils/tokenManager";
import axios from "axios";

// 토큰 응답 타입
export interface TokenResponse {
  accessToken: string;
  refreshToken?: string;
  tokenType?: string;
  expiresIn?: number;
}

// 토큰 재발급 서비스
export class AuthService {
  private baseURL: string;

  constructor() {
    this.baseURL = import.meta.env.VITE_API_HOST || "http://localhost:9010";
  }

  // 토큰 재발급
  async reissueToken(): Promise<any> {
    try {
      // 토큰 디버깅
      debugTokens();

      // refreshToken을 localStorage에서 가져와서 사용
      // const refreshToken = getRefreshToken();

      // if (!refreshToken) {
      //   throw new Error("Refresh token not found");
      // }

      // Site-Id 헤더 포함하여 토큰 재발급 요청
      const selectedSiteId = localStorage.getItem("selectedSiteId");
      const headers: Record<string, string> = {};
      if (selectedSiteId) {
        headers["Site-Id"] = selectedSiteId;
      }

      // 직접 axios 사용 (ApiRepository 의존성 제거)
      const response = await axios.post(
        `${this.baseURL}/common/reissue`,
        // {
        //   refreshToken: refreshToken,
        // },
        {
          headers,
        },
                {        
          withCredentials: true
        }
      );

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        console.log("📡 Axios 에러 상세:", {
          status: error.response?.status,
          statusText: error.response?.statusText,
          data: error.response?.data,
          message: error.message,
        });
      }
      throw error;
    }
  }

  // Delicate logout process
  async logout(): Promise<void> {
    try {
      // 로컬 스토리지 정리
      clearTokens();

      // Vuex store 정리 (store가 있는 경우)
      // store.commit('CLEAR_AUTH');

      // 로그인 페이지로 리다이렉트
      window.location.href = "/login";
    } catch (error) {
      console.error("Logout error:", error);
      // 에러가 발생해도 강제로 로그인 페이지로 이동
      window.location.href = "/login";
    }
  }

  // 토큰 저장
  saveTokens(tokens: TokenResponse): void {
    saveTokensToStorage(tokens);
  }

  // 토큰 유효성 검사
  isTokenValid(): boolean {
    return isTokenValid();
  }

  // 자동 토큰 갱신 (선택사항)
  async autoRefreshToken(): Promise<boolean> {
    try {
      if (this.isTokenValid()) {
        return true; // 토큰이 유효하면 갱신 불필요
      }

      const response = await this.reissueToken();
      if (response.status === 200 && response.data) {
        this.saveTokens(response.data);
        return true;
      }

      return false;
    } catch (error) {
      console.error("자동 토큰 갱신 실패:", error);
      return false;
    }
  }
}
